import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

const QUERY_DELAY = 500;

class DebounceField extends React.Component {
  static propTypes = {
    callback: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { value: this.props.value };
  }

  call = debounce(() => {
    const { callback } = this.props;
    const { value } = this.state;
    if (callback) callback(value);
  }, QUERY_DELAY);

  handleChange = event => {
    this.setState({ value: event.target.value });
    this.call();
  };

  componentWillReceiveProps(newProps) {
    this.setState({ value: newProps.value });
  }

  render() {
    const { callback, value = '', ...props } = this.props;
    return <input {...{ value }} {...props} {...this.state} onChange={this.handleChange} />;
  }
}

export default DebounceField;
